import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { AccountMetricInsightsMetricType } from '../../../../interface/dtos/challenge-insights/account-metrics-insights-metric-type.enum';
import { MetricValueType } from '../../../../interface/dtos';

export interface ChallengeTimeInAppsSummaryEntityProps {
  value: number;
  count: number;
  uniqueUsers?: number;
  type?: MetricValueType;
  date?: string;
}

export class ChallengeTimeInAppsSummaryEntity extends Entity<ChallengeTimeInAppsSummaryEntityProps> {
  protected _id: string;

  public validate(): void {}

  static create(
    props: ChallengeTimeInAppsSummaryEntityProps
  ): ChallengeTimeInAppsSummaryEntity {
    const entity = new ChallengeTimeInAppsSummaryEntity({
      id: v4(),
      props,
    });
    return entity;
  }

  get count(): number {
    return this.props.count;
  }

  get value(): number {
    return this.props.value;
  }

  get average(): number {
    return this.count > 0 ? this.value / this.count : 0;
  }

  get type(): MetricValueType {
    return this.props.type;
  }
  setType(type: MetricValueType): MetricValueType {
    this.props.type = type;
    return this.props.type;
  }

  get metricType(): AccountMetricInsightsMetricType {
    return AccountMetricInsightsMetricType.TimeInApp;
  }

  get uniqueUsers(): number {
    return this.props.uniqueUsers || 0;
  }

  get date() {
    return this.props.date || null;
  }
}
